var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ui-select-field ui-field ui-outline-field" },
    [
      _c("div", { staticClass: "ui-outline-field-wrapper" }, [
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.aValue,
                expression: "aValue",
              },
            ],
            attrs: { id: _vm.name, name: _vm.name, required: !!_vm.required },
            on: {
              input: _vm.onInput,
              change: function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.aValue = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
            },
          },
          [
            _vm.blankString
              ? _c(
                  "option",
                  { attrs: { disabled: "", selected: "", value: "" } },
                  [_vm._v(_vm._s(_vm.blankString))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.options, function (option, i) {
              return _c("option", { domProps: { value: option.value } }, [
                _vm._v(_vm._s(option.name)),
              ])
            }),
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "ui-outline" }, [
          _c("div", { staticClass: "ui-outline-left" }),
          _vm._v(" "),
          _c("div", { staticClass: "ui-outline-middle" }, [
            _c("label", { attrs: { for: _vm.name } }, [
              _vm._v("\n          " + _vm._s(_vm.label) + "\n          "),
              _vm.required
                ? _c("span", { staticClass: "ui-field-required-marker" })
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ui-outline-right" }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "ui-select-field-caret-icon" }, [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 10 10",
              },
            },
            [
              _c("path", {
                attrs: { d: "M0 3h10L5 8", "fill-rule": "nonzero" },
              }),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }